<template>
  <div>
    <Header :title="title" />
    <div class="footer_podat" v-if="podkateg">
      <div class="main">
        <div align="center">
          <button class="btns" @click="dale()">Далее</button>
        </div>
      </div>
    </div>

    <div class="content_podat">
      <div v-if="loading" align="center">
        <div class="spinpodat"><Spinner /></div>
      </div>
      <div v-else>
        <div v-for="pk in arr" :key="pk.id" class="block_radio">
          <input
            class="custom-radio"
            name="color"
            v-model="podkateg"
            type="radio"
            :id="pk.idpodkateg"
            :value="pk.idpodkateg"
            @change="select"
          />
          <label :for="pk.idpodkateg">{{ pk.textpodkateg }} </label>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "../components/headerpodat";
import axios from "axios";
import Spinner from "../blocks/spinner";
export default {
  components: {
    Header,
    Spinner,
  },
  data() {
    return {
      title: "Подкатегория",
      loading: true,
      podkateg: "",
      txtpodkateg: "",
      arr: [],
    };
  },
  methods: {
    select() {
      const values = Object.values(this.arr);
      for (let i = 0; i < values.length; i += 1) {
        if (values[i].idpodkateg === this.podkateg) this.txtpodkateg = values[i].textpodkateg;
      }
      this.$store.commit("addpodatpodkateg", this.podkateg);
      this.$store.commit("addpodatpodkateg_text", this.txtpodkateg);
      this.dale();
    },
    dale() {
      if(this.getkateg=='gruzspes'){
         this.$router.push({name:"marka", params:{id:this.podkateg}});
      }
      else if (this.getkateg=='zapak'){
        if(this.podkateg=='avtozapchasti'){
           this.$router.push({name:"marka", params:{id:'avto'}}); 
        }  
        else if(this.podkateg=='motozapchasti'){
           this.$router.push({name:"marka", params:{id:'moto'}});
        }
        else if(this.podkateg=='shiniidiski'){
          this.$router.push({name:"diska"});
        }  
        else  this.$router.push({name:"info"});  
      }
      else if(this.getkateg=='remus'){
         if(this.podkateg=='drugoy')  this.$router.push({name:"info"});
         else this.$router.push({name:"tip", params:{id:this.podkateg}});
      }
      else   this.$router.push({name:"info"});
    },
  },
  computed: {
    getpodkateg() {
      return this.$store.getters.getpodatpodkateg;
    },
    getkateg() {
      return this.$store.getters.getpodatkateg;
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.go(-1);
    }
  },
  mounted() {
    axios({
      method: "post",
      url: "https://avtobaza.tj/api/getpodkateg",
      data: {
        id: this.$route.params.id,
      },
    }).then((res) => {
      if (res.data.status) {
        this.loading = false;
        this.arr = res.data.podkategs;
        if (this.getpodkateg) this.podkateg = this.getpodkateg;
      } else {
        this.loading = false;
        alert("ERROR");
      }
    });
  },
};
</script>
<style scoped>
.block_radio {
  margin-bottom: 1.4em;
}
.divgorod {
  width: 100%;
  color: #777777;
}
.contentgorod {
  font-size: 20px;
  border-bottom: 1px solid #000000;
  padding: 5px 5px 5px 0px;
}
label {
  font-size: 18px;
  width: 100%;
}
.content_podat {
  padding: 90px 5px 65px 10px;
}
</style>